import { api } from './services';
import { AccessGroup } from '../components/admin/access-groups/store/types';

export const upsertAccessGroup = async (reqBody: AccessGroup) => await api('accessGroups/upsert', { ...reqBody }, 'post');
export const fetchAllAccessGroups = async () => await api('accessGroups/getAll', {}, 'get');
export const deleteAccessGroup = async (reqBody: { accessGroupId: number }) => await api('accessGroups/delete', { ...reqBody }, 'post');
